import { cx } from 'class-variance-authority'

import { PictureTr } from '@/components/atoms'
import { Picture } from '@/types'

type PicturesCheckListProps = {
  pictures: Picture[]
  unmatchedPictures: Picture[]
  className?: string
}

export const PicturesCheckList = ({
  pictures,
  unmatchedPictures,
  className,
}: PicturesCheckListProps) => (
  <div className={cx('flow-root w-full', className)}>
    <div className="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
      <div className="inline-block w-full py-2 align-middle sm:px-6 lg:px-8">
        <table className="w-full divide-y divide-gray-300">
          <thead>
            <tr>
              <th
                scope="col"
                className="w-1/2 py-3 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3"
              >
                Image importée
              </th>
              <th
                scope="col"
                className="py-3 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3"
              >
                Ligne correspondante
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {pictures.map((picture, index) => (
              <PictureTr
                key={`${picture.name}-${picture.productID}`}
                picture={picture}
                index={index}
              />
            ))}
            {unmatchedPictures.map((picture, index) => (
              <PictureTr
                key={`${picture.name}-${index}`}
                picture={picture}
                index={index}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
)
